import React from 'react';

export default function Notes(props){
    return(
        <div>
            <textarea rows="4" cols="50" style={{ overflow:"hidden", borderRadius: 4,  backgroundColor: "#f8f8f8"}}>Notes: </textarea>
        </div>
    );
}